import { useTranslation } from 'react-i18next';

import { ReactComponent as Settings } from 'assets/icons/Settings.svg';
import SettingsCard from 'modules/SettingsModal/SettingsCard/SettingsCard';

import RoleDropdown from '../RoleDropdown';

interface RoleSettingsSectionProps {
  roleId?: string;
  roleName: string;
  onRoleChange: (roleId: string) => void;
}

const RoleSettingsSection = ({ roleId, roleName, onRoleChange }: RoleSettingsSectionProps) => {
  const { t } = useTranslation();

  return (
    <SettingsCard>
      <div className="w-full h-full p-2">
        <SettingsCard.Header title={t('workspaces.role')} icon={Settings} />
        <SettingsCard.Content>
          <div className="flex gap-4 flex-col md:flex-row md:items-center justify-between">
            <div className="flex flex-col space-y-1 w-full">
              <SettingsCard.Content.Title>{t('workspaces.change_role')}</SettingsCard.Content.Title>
              <SettingsCard.Content.Description>{t('workspaces.change_role_desc')}</SettingsCard.Content.Description>
            </div>
            <RoleDropdown roleId={roleId} roleName={roleName} onRoleChange={onRoleChange} />
          </div>
        </SettingsCard.Content>
      </div>
    </SettingsCard>
  );
};

export default RoleSettingsSection;
